import { render, staticRenderFns } from "./AccGym.vue?vue&type=template&id=241111fe"
import script from "./AccGym.vue?vue&type=script&lang=js"
export * from "./AccGym.vue?vue&type=script&lang=js"
import style0 from "./AccGym.vue?vue&type=style&index=0&id=241111fe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports